import * as commonData from "../Common";
import * as actionType from "../constants";

export const columnResize = (inputs) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;

  try {
    const response = await fetch(`${api}attribute/resize`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      console.log("response resize", rdata.data);
    } else {
      console.log(rdata.message);
    }
  } catch (error) {
    console.log(error.message);
  }
};
